import { ReactComponentElement, ReactNode } from 'react';
import Icon from '../../Icon';
import styles from './oneBenefit.module.css';

export interface OneBenefitProps {
  children: ReactNode;
  Icon: ReactComponentElement<typeof Icon>;
}

const OneBenefit = ({ children, Icon }: OneBenefitProps) => (
  <div className={styles.oneBenefit}>
    <div>{Icon}</div>
    <div className={styles.oneBenefitText}>{children}</div>
  </div>
);

export default OneBenefit;
